﻿import { writable } from 'svelte/store';

const myselfLabels = {
    youThey: "you",
    yourTheir: "your",
}

const textStore = () => {
    let store = writable(myselfLabels);

    function switchText(registrationType) {
        if (registrationType !== "Individual (Myself)") {
            store.set({
                youThey:"they",
                yourTheir: "their",
            });
        } else {
            store.set(myselfLabels);
        }
    }

    return {
        ...store,
        switchText,
    };
}

export default textStore();
